import React from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles2 from './fastagModal.module.scss'
import { FASTAG_HEADER_ALT, FASTAG_HEADER_IMG } from './constants'

const getVehicleBanner = ({ autoData = { db_make_name: '', db_model_name: '' }, regNo }) => {
  const { db_make_name: dbMakeName, db_model_name: dbModelName } = autoData
  return (
    <div className={styles2.fastagVehicleDetailsWrapper}>
      <div className={styles2.fastagVehicleDetailsFlex}>
        <div className={styles2.vehicleModal}>
          {Object.keys(autoData)?.length ? (
            <p>
              {dbMakeName} {dbModelName}
            </p>
          ) : null}
          <span>{regNo}</span>
        </div>
      </div>
      <Image
        width={162}
        height={75}
        layout="fixed"
        className={styles2.carImg}
        src={`${assetLoader()}${FASTAG_HEADER_IMG}`}
        alt={FASTAG_HEADER_ALT}
      />
    </div>
  )
}

export default getVehicleBanner
